export function initialize() {
    document.addEventListener('click', function(e: MouseEvent) {
        let current = e.target as HTMLElement;
        let group = current.closest('[data-group-filter]');

        if(group) {
            let inputs = group.querySelectorAll('input:checked');
            let selectedKeys: string[] = [];

            inputs.forEach(function(input) {
                let v = input.getAttribute('value');
                if(v) {
                    selectedKeys.push(input.getAttribute('value') + '');
                }
            });

            document.querySelectorAll('[data-group-filter-item]').forEach(function(item: HTMLElement) {
                let key = item.dataset.groupFilterItem + '';

                if(selectedKeys.length === 0 || selectedKeys.some(v => key.includes(v))) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        }
    });
}
